import { API_CONFIG } from '../config/api';
import type { Attachment } from '../types/attachment';
import {
  getParentAttachments,
  parseAttachmentErrorResponse,
  uploadParentAttachment,
} from './attachmentApi';

export const getItemAttachments = async (itemId: number) => getParentAttachments('item', itemId);

export const getItemImage = async (itemId: number): Promise<Attachment | null> => {
  const attachments = await getItemAttachments(itemId);
  return attachments.find((attachment) => attachment.kind === 'IMAGE') ?? null;
};

const authHeaders = (): Record<string, string> => ({
  Accept: 'application/json',
  Authorization: `Bearer ${localStorage.getItem('token')}`,
});

export const uploadItemImage = async (itemId: number, file: File): Promise<Attachment> =>
  uploadParentAttachment('item', itemId, file);

export const deleteItemImage = async (itemId: number): Promise<void> => {
  const response = await fetch(
    `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.ITEMS.IMAGE}/${itemId}/image`,
    {
      method: 'DELETE',
      headers: authHeaders(),
    }
  );

  if (!response.ok) {
    await parseAttachmentErrorResponse(response, 'Failed to remove item image');
  }
};

export const getInvoiceAttachments = async (invoiceId: number) =>
  getParentAttachments('invoice', invoiceId);

export const getBillAttachments = async (billId: number) => getParentAttachments('bill', billId);

// Re-export parse for any legacy imports
export { parseAttachmentErrorResponse as parseErrorResponse };

// Silence unused import if AttachmentResponse not needed - actually remove AttachmentResponse